import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import HeaderBottom from "../../components/HomePage/HeaderBottom";

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 12;

  useEffect(() => {
    fetch("https://aprilone-178ea8362c0b.herokuapp.com/posts")
      .then((res) => res.json())
      .then((data) => setPosts(data))
      .catch((error) => console.error("Error fetching posts:", error));
  }, []);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);
  const totalPages = Math.ceil(posts.length / postsPerPage);

  const handlePageClick = (pageNumber) => setCurrentPage(pageNumber);
  const handleNext = () => currentPage < totalPages && setCurrentPage(currentPage + 1);
  const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);

  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <>
      <section className="bg-light py-3">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0 custom-banner fs-4 fw-semibold">
              <li className="breadcrumb-item">
                <Link to="/" className="text-decoration-none text-primary">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item active text-dark" aria-current="page">
                Blog
              </li>
            </ol>

          </nav>
        </div>
      </section>


      <main className="main-wrapper min-vh-100">
        <section className="blog1-section-area py-5">
          <div className="container">
            <div className="row g-4">
              {currentPosts.map((post, index) => (
                <div
                  key={post._id}
                  className="col-lg-4 col-md-6 col-sm-12 d-flex"
                  data-aos="zoom-out"
                  data-aos-duration={800 + index * 100}
                >
                  <div className="card border-0 shadow-lg rounded-3 overflow-hidden w-100 d-flex flex-column">
                    <Link to={`/blog/${post.titleSlug}`}>
                      <img
                        src={post.featuredImage}
                        alt="Blog Thumbnail"
                        className="card-img-top"
                        style={{
                          height: "220px",
                          objectFit: "cover",
                          width: "100%",
                        }}
                      />
                    </Link>
                    <div className="card-body d-flex flex-column">
                      <div className="d-flex align-items-center mb-2">
                        <img
                          src="https://i.ibb.co/qYkZdbKQ/calendar-249.png"
                          alt="Calendar"
                          className="me-2"
                          style={{ width: "20px" }}
                        />
                        <span className="text-muted small">{post.postDate}</span>
                      </div>
                      <h5 className="mb-2">
                        <Link
                          to={`/blog/${post.titleSlug}`}
                          className="text-dark text-decoration-none"
                        >
                          {post.postTitle}
                        </Link>
                      </h5>
                      <div className="mt-auto">
                        <Link
                          to={`/blog/${post.titleSlug}`}
                          className="btn btn-primary btn-sm mt-2"
                        >
                          Read More <i className="fa-solid fa-arrow-right ms-1" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="text-center mt-4">
                <nav aria-label="Page navigation">
                  <ul className="pagination justify-content-center flex-wrap">
                    <li className="page-item">
                      <button
                        className="page-link"
                        onClick={handlePrev}
                        disabled={currentPage === 1}
                      >
                        Previous
                      </button>
                    </li>
                    {pageNumbers.map((number) => (
                      <li
                        key={number}
                        className={`page-item ${currentPage === number ? "active" : ""}`}
                      >
                        <button className="page-link" onClick={() => handlePageClick(number)}>
                          {number}
                        </button>
                      </li>
                    ))}
                    <li className="page-item">
                      <button
                        className="page-link"
                        onClick={handleNext}
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </div>
        </section>
      </main>
    </>
  );
};

export default Blog;
